module.exports = __webpack_public_path__ + "assets/img/btn-view-info-022a38cd.png";